import React, { useEffect, useState } from 'react';
import { Table, Button, Tag, message, Space, Popconfirm } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import request from '../../utils/api';

export default function Registrations() {
  const { activityId } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => { loadData(); }, [activityId]);

  async function loadData() {
    setLoading(true);
    try {
      const res = await request.get(`/registrations/admin/${activityId}`);
      setData(res.data);
    } catch (e) {} finally { setLoading(false); }
  }

  async function handleCheckin(id) {
    try {
      await request.post(`/registrations/${id}/checkin`);
      message.success('签到成功');
      loadData();
    } catch (e) { message.error('签到失败'); }
  }

  const columns = [
    { title: '用户', dataIndex: ['user', 'nickname'], key: 'user' },
    { title: '会员等级', key: 'level',
      render: (_, r) => r.user?.memberLevel === 'chief'
        ? <Tag color="gold">👑 大酋长</Tag>
        : <Tag>普通会员</Tag>
    },
    { title: '金额', dataIndex: 'totalAmount', render: v => v ? `¥${v}` : '-' },
    { title: '小孩姓名', dataIndex: 'childName', render: v => v || '-' },
    { title: '小孩年龄', dataIndex: 'childAge', render: v => v || '-' },
    { title: '小孩年级', dataIndex: 'childGrade', render: v => v || '-' },
    { title: '额外大人', dataIndex: 'extraAdultCount', render: v => v || 0 },
    { title: '签到', dataIndex: 'checkIn', render: v => v ? <Tag color="green">已签到</Tag> : <Tag color="orange">未签到</Tag> },
    { title: '报名时间', dataIndex: 'createdAt', render: v => new Date(v).toLocaleString('zh-CN') },
    { title: '操作', key: 'action',
      render: (_, r) => (
        <Space>
          {!r.checkIn && (
            <Popconfirm title="确认签到？" onConfirm={() => handleCheckin(r.id)}>
              <Button size="small" type="primary">签到</Button>
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}>报名管理</h2>
        <Button onClick={() => navigate('/activities')}>← 返回活动列表</Button>
      </div>
      <Table columns={columns} dataSource={data} rowKey="id" loading={loading}
        pagination={{ showTotal: total => `共 ${total} 条报名` }}
      />
    </div>
  );
}
